import type { Plan } from "@/types/planTypes";

export type HostingPlanTier = "starter" | "growth" | "pro" | "unknown";

export function getHostingPlanTier(plan: Pick<Plan, "name">): HostingPlanTier {
	const n = plan.name.trim().toLowerCase();
	if (n === "starter" || n === "basic") return "starter";
	if (n === "growth") return "growth";
	if (n === "pro" || n === "professional") return "pro";
	return "unknown";
}

export const HOSTING_CUSTOM_PLAN_SUPPORT_MESSAGE =
	"Please contact support to tailor a custom hosting plan for you, as you have exceeded the maximum website count on our top hosting plan.";

export function hostingExceedsProPlanMax(count: number): boolean {
	return count > 8;
}

export function hostingTierCoversCount(tier: HostingPlanTier | null, count: number): boolean {
	if (tier === "pro") return count <= 8;
	if (tier === "growth") return count <= 3;
	if (tier === "starter") return count <= 1;
	return false;
}

export function hostingTierRank(tier: HostingPlanTier | null): number {
	switch (tier) {
		case "starter":
			return 1;
		case "growth":
			return 2;
		case "pro":
			return 3;
		default:
			return 0;
	}
}

/** Skip hosting checkout when the user's active plan already covers this site count. */
export function basketHostingWaivedByExistingPlan(
	userActiveHostingTier: HostingPlanTier | null,
	hostingEligibleLineCount: number,
): boolean {
	return hostingTierCoversCount(userActiveHostingTier, hostingEligibleLineCount);
}

/** Stripe prorates when the customer upgrades to a higher hosting tier on an existing subscription. */
export function isExistingHostingTierUpgrade(
	userActiveHostingTier: HostingPlanTier | null,
	selectedPlan: Pick<Plan, "name"> | null | undefined,
): boolean {
	if (!userActiveHostingTier || !selectedPlan) return false;
	const selectedTier = getHostingPlanTier(selectedPlan);
	if (selectedTier === "unknown") return false;
	return hostingTierRank(selectedTier) > hostingTierRank(userActiveHostingTier);
}
